import styled from 'styled-components'

import { TypeStyle, fromMd, zIndexForeground } from '@syconium/little-miss-figgy'

import { Container as MCBContainer } from '../../../../../../brunswick/components/ModalCloseButton/styles'
import { NextModalStyles } from '../../../../../modals/NextModal'

export const modalStyles: NextModalStyles = {
  content: {
    borderRadius: 0,
    borderWidth: 0,
    bottom: 'initial',
    boxSizing: 'border-box',
    left: 'initial',
    overflow: 'initial',
    padding: 'initial',
    position: 'initial',
    right: 'initial',
    top: 'initial',
    width: '960px',
  },
  overlay: {
    backgroundColor: undefined,
  },
}

export const Body = styled.div`
  overflow: auto;
`

export const Header = styled.header`
  align-items: center;
  background-color: white;
  display: flex;
  justify-content: center;
  line-height: 26px;
  padding: 17px 0;
  position: sticky;
  top: 0;
  z-index: ${zIndexForeground};

  ${MCBContainer} {
    height: 100%;
    padding-bottom: 0;
    padding-top: 0;
  }

  ${fromMd} {
    padding: 24px 0;
  }
`

export const Title = styled.h2`
  font-weight: bold;
  letter-spacing: 1px;
  text-transform: uppercase;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  ${fromMd} {
    flex-direction: row;
    height: 550px;
  }
`

export const TextWrapper = styled.div`
  flex: 1;

  ${fromMd} {
    overflow-y: auto;
    padding: 0 40px;
  }
`

export const ImageWrapper = styled.div`
  flex: 1;

  ${fromMd} {
    margin-top: 0;
    margin-bottom: 40px;

    margin-inline-start: 40px;
    margin-inline-end: 0;
  }
`

export const Summary = styled.div`
  padding: 16px;

  ${fromMd} {
    padding: 0;
  }
`

export const FullDetailsButton = styled(TypeStyle.HeadlineExtraExtraSmall)`
  margin: 12px 0;
  text-decoration: underline;

  ${fromMd} {
    margin: 16px 0 32px;
  }
`
